import React from 'react';
import { Table, Empty, Checkbox } from 'antd';

export default function Productos(props) {
    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Código',
                        dataIndex: 'codigoReferencia',
                        key: 'codigoReferencia',
                        align: 'center'
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida'
                    },
                    {
                        title: 'Afecto IGV',
                        dataIndex: 'flagAfecto',
                        key: 'flagAfecto',
                        align: 'center',
                        width: 62,
                        render: (value, row) => {
                            return (
                                <Checkbox
                                    checked={value}
                                    disabled={true}
                                />
                            );
                        }
                    },
                    {
                        title: 'Gratuito',
                        dataIndex: 'flagGratuito',
                        key: 'flagGratuito',
                        align: 'center',
                        width: 62,
                        render: (value, row) => {
                            return (
                                <Checkbox
                                    checked={value}
                                    disabled={true}
                                />
                            );
                        }
                    },
                    {
                        title: 'Precio Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(5)}</span>
                        )
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(3)}</span>
                        )
                    },
                    {
                        title: 'Total Detalle',
                        dataIndex: 'totalDetalle',
                        key: 'totalDetalle',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    },
                    {
                        title: 'Porcentaje Descuento',
                        dataIndex: 'porcentajeDescuento',
                        key: 'porcentajeDescuento',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    },
                    {
                        title: 'Importe Descuento',
                        dataIndex: 'importeDescuento',
                        key: 'importeDescuento',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'right',
                        width: 80,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    }
                ]}
            />
        </div>
    );
}